// extracted by mini-css-extract-plugin
var _1 = "webpack-components-NavigationTabs-NavigationTabs-module__activeText";
var _2 = "webpack-components-NavigationTabs-NavigationTabs-module__badge";
var _3 = "webpack-components-NavigationTabs-NavigationTabs-module__secondaryItems";
var _4 = "webpack-components-NavigationTabs-NavigationTabs-module__statusBarContents";
var _5 = "webpack-components-NavigationTabs-NavigationTabs-module__tabActive";
var _6 = "webpack-components-NavigationTabs-NavigationTabs-module__tabItem";
var _7 = "webpack-components-NavigationTabs-NavigationTabs-module__tabsOuterWrapper";
var _8 = "webpack-components-NavigationTabs-NavigationTabs-module__tabsWrapper";
var _9 = "webpack-components-NavigationTabs-NavigationTabs-module__text";
export { _1 as "activeText", _2 as "badge", _3 as "secondaryItems", _4 as "statusBarContents", _5 as "tabActive", _6 as "tabItem", _7 as "tabsOuterWrapper", _8 as "tabsWrapper", _9 as "text" }
